import { forwardRef } from 'react';
import { Box, Dialog, type DialogProps } from '@mui/material';
import { Slide } from '@mui/material';

import { FormPageHeader } from '../../page/header/form-page-header';
import { PageContent } from '../../page/page-content';

const Transition = forwardRef(function Transition(
  props: React.ComponentProps<typeof Slide>,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" enter exit ref={ref} {...props} />;
});

export type SubFormDialogProps = DialogProps & {
  /**
   * Title to display at the top of the dialog.
   */
  title: string;

  /**
   * Function to close the dialog.
   */
  onClose: () => void;
};

export const SubFormDialog = ({
  title,

  onClose,

  children,

  ...props
}: SubFormDialogProps) => {
  return (
    <Dialog
      fullScreen
      maxWidth="sm"
      slots={{
        transition: Transition,
      }}
      {...props}>
      <FormPageHeader onNavigationIconClick={onClose} title={title} />
      <PageContent>
        <Box sx={{ flex: 1 }}>{children}</Box>
      </PageContent>
    </Dialog>
  );
};
